{
    "customerName": {
        "type": "text",
        "fields": {
            "id": "#customerName",
            "reviewId": "#review_customerName"

        }
    },
    "customerAddress": {
        "type": "text",
        "fields": {
            "id": "#customerAddress",
            "reviewId": "#review_customerAddress"

        }
    },
    "customerZipCodeAndCity": {
        "type": "text",
        "fields": {
            "id": "#customerZipCodeAndCity",
            "reviewId": "#review_customerZipCodeAndCity"

        }
    },
    "customerOrganizationNumber": {
        "type": "text",
        "fields": {
            "id": "#customerOrganizationNumber",
            "reviewId": "#review_customerOrganizationNumber"

        }
    },
    "deliveryAddresses": {
        "type": "checkbox",
        "fields": {
            "groupClass": ".form-addresses",
            "reviewId": "#review_addresses"
        }
    }

}
